import { render } from "./WelcomeGreeting.vue?vue&type=template&id=5a62b44c&scoped=true"
import script from "./WelcomeGreeting.vue?vue&type=script&lang=js"
export * from "./WelcomeGreeting.vue?vue&type=script&lang=js"

import "./WelcomeGreeting.vue?vue&type=style&index=0&id=5a62b44c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a62b44c"]])

export default __exports__